import { createAction, props } from '@ngrx/store';

export const GlobalActions = {
  globalClear: createAction('[Global] Clear State'),
};

export default GlobalActions;
